"use client";

import { useCallback, useRef } from "react";

import type { EventName } from "@/lib/analytics/trackEvent";
import { safeTrack } from "@/lib/safeTrack";

function getSessionId(): string {
  if (typeof window === "undefined") return "ssr";
  const key = "expirydesk:session_id";
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(key, id);
  }
  return id;
}

export function useTrackEvent() {
  const sessionId = useRef<string | null>(null);

  const track = useCallback(async (eventName: EventName, properties?: Record<string, unknown>) => {
    if (!sessionId.current) {
      sessionId.current = getSessionId();
    }
    safeTrack(async () => {
      await fetch("/api/analytics/track", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          eventName,
          sessionId: sessionId.current,
          properties,
        }),
        keepalive: true,
      });
    }, "useTrackEvent");
  }, []);

  return { track };
}
